import { chipLabel } from "../jobCompleteness";

// Small marker for a job whose numbers are still missing something. The reasons show on hover.
// Says "Incomplete" only when the job's margin is withheld; otherwise it names the reason, for example
// "2 expenses to review" (see chipLabel in src/jobCompleteness.js). Renders nothing for a complete job.
// Pass the result of jobCompleteness() and the result of marginView() for the same job.
function IncompleteChip({ completeness, margin, style }) {
  const text = chipLabel(completeness, margin);
  if (!text) return null;
  return (
    <span className="chip a" title={[...completeness.reasons, ...(completeness.softNotes || [])].join(". ")}
      style={{ fontSize:9, padding:"1px 7px", whiteSpace:"nowrap", ...style }}>{text}</span>
  );
}

export { IncompleteChip };
